import { Button } from 'components/Button'
import { TabbedMenu } from 'components/TabbedMenu/TabbedMenu'
import { Text } from 'components/Text'
import { useEffect, useState } from 'react'
import { Box, Flex, Heading } from 'theme-ui'
import { DCReflectionAnswersData } from 'types/dc'

export function DCQuestionnaires(reflectionAnswers: DCReflectionAnswersData) {
  const [selectedDay, setSelectedDay] = useState('day1')
  const [answers, setAnswers] = useState<
    {
      questionText: string
      questionAnswers: string
    }[]
  >()
  useEffect(() => {
    setAnswers(reflectionAnswers[selectedDay as keyof typeof reflectionAnswers])
    // eslint-disable-next-line
  }, [selectedDay])

  return (
    <Box
      sx={{
        p: '60px 70px 60px 90px',
        mt: '40px',
        mb: '100px',
        width: '100%',
      }}
    >
      <Flex
        sx={{
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Heading variant="text.h2">Reflection Questions</Heading>
        <TabbedMenu
          options={[
            <Button
              data-cy={`dc-questionnaire-tab-day1`}
              variant={`tabbedMenu.buttons.${
                selectedDay === 'day1' ? 'selected' : 'unselected'
              }`}
              children="Day 1"
              onClick={() => setSelectedDay('day1')}
            />,
            <Button
              data-cy={`dc-questionnaire-tab-day2`}
              variant={`tabbedMenu.buttons.${
                selectedDay === 'day2' ? 'selected' : 'unselected'
              }`}
              children="Day 2"
              onClick={() => setSelectedDay('day2')}
            />,
            <Button
              data-cy={`dc-questionnaire-tab-day3`}
              variant={`tabbedMenu.buttons.${
                selectedDay === 'day3' ? 'selected' : 'unselected'
              }`}
              children="Day 3"
              onClick={() => setSelectedDay('day3')}
            />,
          ]}
        />
      </Flex>
      {
        <Box sx={{ marginTop: '80px' }}>
          {answers && answers.length > 0 ? (
            answers.map((key, index) => {
              return (
                <Box key={index} sx={{ marginTop: 6 }}>
                  <Text
                    key={index + 'header'}
                    variant="tabbedMenu.questionText"
                  >
                    {index + 1 + '. ' + key.questionText}
                  </Text>
                  <Text
                    key={key + 'answer'}
                    variant="tabbedMenu.questionAnswer"
                    sx={{ pt: 20 }}
                  >
                    {key.questionAnswers !== undefined && key.questionAnswers}
                  </Text>
                </Box>
              )
            })
          ) : (
            <Box>
              <Text variant="text.basic">
                Your student has not yet answered any reflection questions for
                this day.
              </Text>
            </Box>
          )}
        </Box>
      }
    </Box>
  )
}
